import { escapeRegExp } from '@cli-utils/text.js'

export function replacePathSegments(value: string, before: string, after: string): string {
  const variants: Array<[string, string]> = [
    [`${before}Html`, `${after}Html`],
    [before, after]
  ]

  let next = value
  for (const [from, to] of variants) {
    next = next.replace(
      new RegExp(`(^|[.\\-/])${escapeRegExp(from)}(?=$|[.\\-/])`, 'g'),
      (_, prefix: string) => `${prefix}${to}`
    )
  }

  return next
}
